import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import Ripples from "react-ripples";
import * as XLSX from "xlsx";
import { useAxiosKaraokeConfigGlobal } from "../../../Config/axios";
import assets from "../../../../assets/assets";
import { IconController, ImgController } from "../../../Scripts/ImgController";
import { distributionUrl, karaokeUrl } from "../../../Config/url";
import { useSearchParams } from "react-router-dom";
const Wrapper = styled.div`
  .table-border {
    border: 1px solid #e5e7eb;
  }
  .table-button {
    border: 1px solid #d1d5db;
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    padding: 8px 12px;
    gap: 4px;
    cursor: pointer;
  }
  .table-button:hover {
    border: 1px solid #cde0ff;
    background: #cde0ff;
  }
  .color-CK {
    color: #333843;
  }
  table {
    width: 100%;
  }
  .table-header {
    background: #f3f4f6;
  }
  .list td {
    width: 21.6%;
    padding: 24px;
  }
  .list td:first-child {
    width: 35.2%;
  }
  .skeleton td {
    width: 21.6%;
    padding: 12px 24px;
  }
  .skeleton td:first-child {
    width: 35.2%;
  }
  .text-color-grey {
    color: #6b7280;
  }
  tr {
    border-bottom: 1px solid #e5e7eb;
  }
  tr:last-child {
    border-bottom: none;
  }
  .table-footer {
    border-top: 1px solid #d1d5db;
    width: 100%;
    padding: 16px 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .active {
    color: #ffffff;
    background-color: #0061ff;
  }
  .incomes-number span {
    color: #10b981;
  }
  @media (max-width: 767px) {
    .list td {
      padding: 12px;
    }
    .skeleton td {
      padding: 12px;
    }
    .table-footer {
      flex-direction: column;
      gap: 12px;
      padding: 12px;
    }
  }
`;

const KaraokeIncomeBreakDown = ({ oneRingRulesAll }) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const date = searchParams.get("date");
  const [dataList, setDataList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [listMeta, setListMeta] = useState(Object);
  const [listLinks, setListLinks] = useState(Object);
  const [timeSort, setTimeSort] = useState(date);

  const [sortTitle, setSortTitle] = useState("");
  const [paginationLinks, setPaginationLinks] = useState([]);
  const context = location.pathname.includes("/karaoke") ? "karaoke" : "music";
  const navigate = useNavigate();
  const [requestParams, setRequestParams] = useState(
    `panel-api/oauth/transactions/${timeSort}?page[number]=${pageNumber}&page[size]=10`
  );
  const axiosConfig = useAxiosKaraokeConfigGlobal();
  const [listLoaded, setListLoaded] = useState(false);
  const [titleTime, setTitleTime] = useState(false);

  const sortParam = `${titleTime ? "" : "-"}${sortTitle}`;

  useEffect(() => {
    axios
      .get(karaokeUrl + requestParams, axiosConfig)
      .then(async (res) => {
        const originalList = res.data.data;
        const ids = originalList.map((song) => song.song_id).join(",");

        try {
          const response = await axios.get(
            distributionUrl + `panel-api/oauth/songs/ids?ids=${ids}`,
            axiosConfig
          );

          const enrichedList = originalList.map((item) => ({
            ...item,
            song: response.data.data.find(
              (data) => data.id === Number(item.song_id)
            ),
          }));

          setDataList(enrichedList);
          setListMeta(res.data.meta);
          setListLinks(res.data.links);
          setPageNumber(res.data.meta.current_page);
          setListLoaded(true);
          generatePagination(
            res.data.meta.current_page,
            res.data.meta.last_page,
            res.data.meta.links[1].url
          );
        } catch (innerErr) {
          console.error("Error fetching song details:", innerErr);
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          oneRingRulesAll("logout");
        } else {
          console.error("API Error:", err);
        }
      });
  }, [requestParams]);

  const fetchTransactions = async () => {
    try {
      const response = await axios.get(
        `${karaokeUrl}panel-api/oauth/transactions/${date}?sort=${sortParam}&source=download`,
        axiosConfig
      );
      return response.data.data;
    } catch (err) {
      if (err.response?.status === 401) {
        oneRingRulesAll("logout");
      } else {
        console.error("API Error:", err);
      }
    }
  };

  function generatePagination(currentPage, totalPages, urlExample) {
    const reqUrl = urlExample.slice(0, -1);
    const pagination = [];

    // "Previous" arrow
    if (currentPage > 1) {
      pagination.push({
        label: "&laquo; Previous",
        active: false,
        url: reqUrl + (currentPage - 1),
      });
    }

    // Page numbers
    pagination.push({
      label: 1,
      active: 1 === currentPage,
      url: 1 === currentPage ? null : reqUrl,
    });

    if (currentPage > 3) {
      pagination.push({
        label: "...",
        active: false,
        url: null,
      });
    }

    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 1, currentPage + 1);
      i++
    ) {
      pagination.push({
        label: i,
        active: i === currentPage,
        url: i === currentPage ? null : reqUrl + i,
      });
    }

    if (currentPage < totalPages - 2) {
      pagination.push({
        label: "...",
        active: false,
        url: null,
      });
    }

    pagination.push({
      label: totalPages,
      active: totalPages === currentPage,
      url: totalPages === currentPage ? null : reqUrl + totalPages,
    });

    // "Next" arrow
    if (currentPage < totalPages) {
      pagination.push({
        label: "Next &raquo;",
        active: false,
        url: reqUrl + (currentPage + 1),
      });
    }
    setPaginationLinks(pagination);
  }

  const export2Excel = async () => {
    const fullData = await fetchTransactions();
    const ws = XLSX.utils.json_to_sheet(fullData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "data.xlsx");
  };
  const mappedList = dataList.map((data) => {
    return (
      <tr key={data.song_id} className="list">
        <td>
          <div className="flex flex-row items-center gap-2">
            <ImgController
              src={data?.song?.cover}
              className="w-11 h-11"
              imgClassName="rounded-lg"
            />
            <div className="flex flex-col text-start ">
              <h5 className="text-xs font-medium text-color-grey">
                {data?.song?.artist?.name}
              </h5>
              <h5 className="text-sm font-medium">
                {data?.song?.title ?? data.song_title}
              </h5>
            </div>
          </div>
        </td>

        <td className="incomes-number text-center">
          <span className="text-[14px] font-semibold leading-5">
            {new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(data.total_revenue_share)}
            ₮
          </span>
        </td>

        <td className="text-center">
          <span className="text-[14px] leading-5">
            {new Intl.NumberFormat("en-US", {
              maximumFractionDigits: 2,
            }).format(data.sang_count)}
          </span>
        </td>
      </tr>
    );
  });

  const mappedPagination = paginationLinks?.map((link) => {
    const trimmedLink = link?.url?.split(
      karaokeUrl.replace("http://", "").replace("https://", "")
    )[1];
    if (link.label === "&laquo; Previous") {
      return (
        <Ripples
          color="#ffffff40"
          during={600}
          className="rounded-lg"
          key={link.label}
        >
          <div
            className="pagination-bg hasHover"
            onClick={() => {
              if (link.url !== null) {
                setRequestParams(trimmedLink);
                setListLoaded(false);
              }
            }}
          >
            ⬅
          </div>
        </Ripples>
      );
    }
    if (link.label === "Next &raquo;") {
      return (
        <Ripples
          color="#ffffff40"
          during={600}
          className="rounded-lg"
          key={link.label}
        >
          <div
            className="pagination-bg hasHover"
            onClick={() => {
              if (link.url !== null) {
                setRequestParams(trimmedLink);
                setListLoaded(false);
              }
            }}
          >
            ⮕
          </div>
        </Ripples>
      );
    } else {
      return (
        <Ripples
          color="#ffffff40"
          during={600}
          className="rounded-lg"
          key={link.label === "..." ? Math.random() : link.label}
        >
          <div
            className={`pagination-bg ${link?.active ? "active" : "hasHover"}`}
            onClick={() => {
              if (link.url !== null) {
                setRequestParams(trimmedLink);
                setListLoaded(false);
              }
            }}
          >
            <span className="font-inter text-sm font-bold">{link?.label}</span>
          </div>
        </Ripples>
      );
    }
  });

  const ListSkeleton = () => {
    const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    return arr.map((a) => {
      return (
        <tr key={a} className="skeleton">
          <td>
            <div className="flex flex-row items-center gap-3">
              <Skeleton height="44px" width="44px" />
              <div className="flex flex-col w-full" height="32px">
                <Skeleton height="8px" width="50%" />
                <Skeleton height="8px" width="75%" />
                <Skeleton height="8px" width="25%" />
              </div>
            </div>
          </td>
          <td>
            <Skeleton width="50%" />
          </td>
          <td>
            <Skeleton width="50%" />
          </td>
        </tr>
      );
    });
  };

  // sort
  const sortHandler = (value) => {
    setTitleTime(!titleTime);
    setSortTitle((titleTime ? "" : "-") + value);
    setRequestParams(
      `panel-api/oauth/transactions/${timeSort}?sort=${
        (titleTime ? "" : "-") + value
      }&page[number]=${pageNumber}&page[size]=10`
    );
  };

  return (
    <Wrapper className="py-4 px-1 md:py-8 md:px-5">
      <div className="px-3 pb-4">
        <div className="flex items-center pb-3 gap-2">
          <div
            onClick={() => {
              navigate(`/${context}`);
            }}
          >
            <h5 className="color-CK hover:text-mmusic cursor-pointer">
              Хэтэвч
            </h5>
          </div>
          <IconController
            src={assets.svg.ChevronRightBlue}
            alt=""
            className="w-4 h-4"
          />
          <h5 className="color-CK-active">Орлогын задаргаа</h5>
        </div>

        <h5 className="font-semibold text-xl text-mmusic">{date}</h5>
      </div>

      <div className="px-3 pt-2">
        <div className="table-border rounded-lg overflow-hidden pt-2">
          <div className="px-4 md:px-6 py-4 md:py-5 flex flex-row justify-between items-center gap-3">
            <h4 className="font-medium text-base md:text-lg">Гүйлгээний хүснэгт</h4>
            <div className="flex flex-row gap-3">
              {/* <div className="table-button">
                        <span className="text-xs font-medium color-grey">Эрэмблэх</span>
                        <IconController src={assets.svg.CreationSort} className="w-4 h-4" />
                     </div> */}
              <Ripples color="#0061FF40" during={600} className="rounded-2xl">
                <div
                  className="table-button"
                  onClick={() => {
                    export2Excel();
                  }}
                >
                  <span className="text-xs font-medium color-grey">Татах</span>
                  <IconController
                    src={assets.svg.DocumentDownload}
                    className="w-4 h-4"
                  />
                </div>
              </Ripples>
            </div>
          </div>
          <div className="overflow-x-auto">
          <table className="min-w-[560px]">
            <thead>
              <tr className="table-header">
                <th>
                  <Ripples color="#0061FF40" during={600} className="w-full">
                    <div
                      className="px-6 py-4 w-full flex flex-row justify-between cursor-pointer"
                      onClick={() => {
                        sortHandler("song_title");
                      }}
                    >
                      <h5 className="text-sm font-medium">Уран бүтээл</h5>

                      <IconController
                        src={assets.svg.ChevronDown}
                        className={`w-5 h-5 ${
                          sortTitle === "-song_title" ? "rotate-180" : ""
                        } `}
                      />
                    </div>
                  </Ripples>
                </th>
                <th>
                  <Ripples color="#0061FF40" during={600} className="w-full">
                    <div
                      className="px-6 py-4 w-full flex flex-row justify-center cursor-pointer relative"
                      onClick={() => {
                        sortHandler("total_revenue_share");
                      }}
                    >
                      <h5 className="text-sm font-medium">Орлого</h5>
                      <div className="absolute right-3">
                        <IconController
                          src={assets.svg.ChevronDown}
                          className={`w-5 h-5 ${
                            sortTitle === "total_revenue_share"
                              ? "rotate-180"
                              : ""
                          } `}
                        />
                      </div>
                    </div>
                  </Ripples>
                </th>
              <th>
                  <Ripples color="#0061FF40" during={600} className="w-full">
                    <div
                      className="px-6 py-4 w-full flex flex-row justify-center cursor-pointer relative"
                      onClick={() => {
                        sortHandler("sang_count");
                      }}
                    >
                      <h5 className="text-sm font-medium">Дуулалт</h5>
                      <div className="absolute right-5">
                        <IconController
                          src={assets.svg.ChevronDown}
                          className={`w-5 h-5 ${
                            sortTitle === "sang_count" ? "rotate-180" : ""
                          } `}
                        />
                      </div>
                    </div>
                  </Ripples>
                </th>
              </tr>
            </thead>
            <tbody>{listLoaded ? mappedList : ListSkeleton()}</tbody>
          </table>
          </div>
          <div className="table-footer">
            <h5 className="text-sm font-medium text-center md:text-left">
              нийт {listMeta?.total} дуунаас {listMeta?.from}-{listMeta?.to}{" "}
              харуулж байна
            </h5>
            <div className="flex flex-row flex-wrap justify-center gap-1 md:gap-2">{mappedPagination}</div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default KaraokeIncomeBreakDown;
